import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";

export default function ItinererDialog({data, open, onClose, departureStationId, arrivalStationId}) {

    const calculateTime = (baseTime, addTime) => {
        const [baseHours, baseMinutes, baseSeconds] = baseTime.split(':').map(Number);
        const [addHours, addMinutes, addSeconds] = addTime.split(':').map(Number);

        let totalSeconds = baseSeconds + addSeconds;
        let totalMinutes = baseMinutes + addMinutes + Math.floor(totalSeconds / 60);
        let totalHours = baseHours + addHours + Math.floor(totalMinutes / 60);

        totalSeconds %= 60;
        totalMinutes %= 60;
        totalHours %= 24;

        return `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;
    };

    const formatTime = (base, add) => {
        if (!base || !add) return "/";
        return calculateTime(base, add).slice(0, 5);
    };

    const formatNumber = (value) => (value != null && value !== "" ? `${value}` : "/");

    const getSearchedSegment = () => {
        if (!Array.isArray(data) || !departureStationId || !arrivalStationId) return null;

        const startIdx = data.findIndex(it => it.station?.id === departureStationId);
        let endIdx = -1;
        for (let i = data.length - 1; i >= 0; i--) {
            if (data[i].station?.id === arrivalStationId) {
                endIdx = i;
                break;
            }
        }
        if (startIdx === -1 || endIdx === -1 || endIdx <= startIdx) return null;

        let total = 0;
        for (let i = startIdx + 1; i <= endIdx; i++) {
            const prev = Number(data[i - 1].distanceInKm) || 0;
            const cur = Number(data[i].distanceInKm) || 0;
            const delta = cur - prev;
            total += delta > 0 ? delta : cur;
        }
        if (!(total > 0)) return null;

        return {
            from: data[startIdx].station?.name || "/",
            to: data[endIdx].station?.name || "/",
            distance: Math.round(total * 100) / 100
        };
    };

    const segment = getSearchedSegment();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Itinerer</DialogTitle>
            <DialogContent dividers>
                {segment && (
                    <Alert severity="info" variant="outlined" sx={{mb: 2}}>
                        Razdaljina ({segment.from} -> {segment.to}):{' '}
                        <strong>{segment.distance} km</strong>
                    </Alert>
                )}
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{fontWeight: 600}}>Stanica</TableCell>
                            <TableCell align="center" sx={{fontWeight: 600}}>Dolazak</TableCell>
                            <TableCell align="center" sx={{fontWeight: 600}}>Polazak</TableCell>
                            <TableCell align="right" sx={{fontWeight: 600}}>Udaljenost od početne (km)</TableCell>
                            <TableCell align="right" sx={{fontWeight: 600}}>Udaljenost od granice (km)</TableCell>
                            <TableCell sx={{fontWeight: 600}}>Komentar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(data || []).map((item, index) => (
                            <TableRow key={index} hover>
                                <TableCell>
                                    <Typography variant="subtitle2">{item.station?.name || "/"}</Typography>
                                </TableCell>
                                <TableCell align="center">{formatTime(item.tripDepartureTime, item.arrivalTime)}</TableCell>
                                <TableCell align="center">{formatTime(item.tripDepartureTime, item.departureTime)}</TableCell>
                                <TableCell align="right">{formatNumber(item.distanceInKm)}</TableCell>
                                <TableCell align="right">{formatNumber(item.borderDistance)}</TableCell>
                                <TableCell>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.comment || "/"}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Zatvori
                </Button>
            </DialogActions>
        </Dialog>
    );
}
